import styles from './panels.module.scss'
import classNames from 'classnames'
import { CommonContainerProps as CommonProps } from 'types/utilities'
interface PanelProps extends CommonProps {
  hasShadow?: boolean
  fullWidthAtTablet?: boolean
}

export const Panel = ({
  children,
  as: Tag = 'div',
  className = '',
  hasShadow = false,
  fullWidthAtTablet = false,
}: PanelProps) => {
  return (
    <Tag
      className={classNames(styles.panel, className, {
        [styles.shadow]: hasShadow,
        [styles.fullWidthAtTablet]: fullWidthAtTablet,
      })}
    >
      {children}
    </Tag>
  )
}

interface InnerPanelProps extends CommonProps {}

export const InnerPanel = ({ children, as: Tag = 'div', className = '' }: InnerPanelProps) => {
  return <Tag className={classNames(styles.innerPanel, className)}>{children}</Tag>
}

export default Panel
